import { COMMERCIAL } from 'constants/AppConstants';
import React, { useEffect } from 'lib/react';
import { EVGrid, EVPaper, EVTypography } from 'lib/components';
import clsx from 'lib/clsx';
import { useTranslation } from 'lib/translation';
import Map from 'commonComponents/map';
import MapDisclaimer from 'commonComponents/map-disclaimer';
import BuildingDetailsListItem from 'commonComponents/building-details-list-item';
import { useDispatch, useSelector } from 'lib/redux';
import { UPDATE_FOCUSED_POINT_SITEMAP, LOAD_SITEMAP_DATA, CLEAR_SITEMAP_DATA } from 'constants/ActionTypes';
import RetryScreen from 'commonComponents/retry-screen';
import SitemapStyles from './SitemapStyles';
import LoadingScreen from './LoadingScreen.component';

function Sitemap() {
  const classes = SitemapStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    reportDetails, focusedPointIndex, reportAddresses, error, loading,
  } = useSelector(({ sitemap }) => sitemap);

  const fetchData = () => dispatch({ type: LOAD_SITEMAP_DATA });

  useEffect(() => {
    fetchData();

    return () => dispatch({ type: CLEAR_SITEMAP_DATA });
  }, []);

  const handleFocusChange = (index) => dispatch({
    type: UPDATE_FOCUSED_POINT_SITEMAP,
    focusedPointIndex: (index === focusedPointIndex) ? null : index,
  });

  const handleRemoveFocus = () => dispatch({ type: UPDATE_FOCUSED_POINT_SITEMAP, focusedPointIndex: null });

  const handleBuildingDetailClick = (index) => (e) => {
    e.stopPropagation();
    handleFocusChange(index);
  };

  if (error) return <RetryScreen handleRetryButtonClick={fetchData} />;

  const render = () => {
    if (loading) return <LoadingScreen />;

    return (
      <>
        <EVGrid className={classes.mapContainer}>
          <Map
            center={reportAddresses[focusedPointIndex]?.address}
            mapPoints={reportAddresses}
            isComplex
            propertyType={COMMERCIAL}
            focusedPinIndex={focusedPointIndex}
            onFocusChange={handleFocusChange}
          />
          <MapDisclaimer />
        </EVGrid>
        <EVGrid className={clsx(classes.flexColumn, classes.buildingsContainer)}>
          <EVTypography className={classes.buildingsHeading}>{t('order_submitted__buildings')}</EVTypography>
          <EVGrid>
            <EVTypography className={classes.propertyTypeHeading}>{t('order_submitted__product_type')}</EVTypography>
            <EVTypography className={classes.propertyType}>{reportDetails.reportType}</EVTypography>
          </EVGrid>
          <EVGrid className={clsx(classes.flexColumn, classes.buildingDetailsList)} onClick={handleRemoveFocus}>
            {
          reportAddresses.map(({ address, building }, index, arr) => (
            <BuildingDetailsListItem
              key={`${building}-${index + 1}-${arr.length}`}
              address={address}
              building={building}
              isFocused={index === focusedPointIndex}
              isComplex
              index={index}
              handleClick={handleBuildingDetailClick(index)}
            />
          ))
        }
          </EVGrid>
        </EVGrid>
      </>
    );
  };

  return (
    <EVPaper className={classes.sitemapPaper}>
      {render()}
    </EVPaper>
  );
}

export default Sitemap;
